import { FC, useMemo, useState } from "react";
import { GRID_MODAL_ROW_STYLES } from "../../detailedPages";
import { ToggleExtended } from "../../general";
import {
  BadgedInputProps,
  BadgesGroupsWithInput,
} from "./BadgesGroupsWithInput";

type BadgedTextProps = BadgedInputProps & {
  isModal?: boolean;
  initExtended?: boolean;
  title: string;
  fullList?: string[];
  textareaPostscript?: string;
};

export const BadgedText: FC<BadgedTextProps> = ({
  isModal = true,
  initExtended = true,
  title,
  customActiveData,
  currentActiveData,
  handleBadgedData,
  predefinedValuesGroups,
  fullList = [],
  inputPlaceholder,
  textareaPostscript = "",
}) => {
  const [extended, setExtended] = useState(initExtended);

  const badgedDataLength = useMemo(() => {
    const currentClasses = currentActiveData?.filter(
      (item) => item.trim() !== "",
    );
    return currentClasses ? currentClasses.length : fullList.length;
  }, [currentActiveData]);

  return (
    <div
      className={
        isModal
          ? GRID_MODAL_ROW_STYLES
          : "flex w-full flex-wrap items-center justify-between gap-5 p-4 text-sm"
      }
    >
      <label
        htmlFor="manualBadges"
        className={
          isModal
            ? "mr-2.5 wrap-break-word text-left text-sm text-stone-700 dark:text-stone-300"
            : "text-primary flex flex-1 items-center"
        }
      >
        {title} ({badgedDataLength})
      </label>
      <div className="flex justify-end">
        <ToggleExtended setExtended={setExtended} extended={extended} />
      </div>
      {extended ? (
        <BadgesGroupsWithInput
          customActiveData={customActiveData}
          currentActiveData={currentActiveData ?? []}
          handleBadgedData={handleBadgedData}
          predefinedValuesGroups={predefinedValuesGroups}
          inputPlaceholder={inputPlaceholder}
        />
      ) : (
        <textarea
          placeholder={`Separate items with new line. ${textareaPostscript}`}
          className={
            isModal
              ? "block col-span-2 w-full justify-self-end rounded-md border-stone-200 bg-stone-50 py-0.5 text-sm dark:border-none  dark:bg-stone-700 dark:text-white h-[100px]"
              : "w-full col-span-2 rounded-md border border-stone-300 px-2 py-0.5 text-sm shadow-sm focus:border-stone-500 focus:ring-stone-500 disabled:cursor-not-allowed dark:border-stone-800 dark:bg-stone-700 dark:text-white h-[205px]"
          }
          onChange={({ target }) => {
            const newClasses = target.value.split("\n");
            handleBadgedData(newClasses);
          }}
          value={(currentActiveData ?? fullList).join("\n")}
        />
      )}
    </div>
  );
};
